import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
	Icon,
	Button,
	Intent,
	Alert,
	Checkbox,
} from '@blueprintjs/core';

import AddEditPaymentType from './AddEditPaymentType';
import { addPaymentType, deletePaymentType } from '../../slices/CodeTablesSlice';

import { ResultHeader, ResultHeaderWithSort, Result, TextFilter } from './ResultComponents';

function Results(props) {
	const {
		table_items,
		table_items_sort_ids,
		table_items_sort_field,
		table_items_sort_direction,
		setTableItemsSort,
		openAddEditItemDialog,
		tableItemsFilters,
		handleFilterChange,
		deleteItem,
	} = props;
	
	const sort_props = {
		setTableItemsSort:       setTableItemsSort,
		tableItemsSortField:     table_items_sort_field,
		tableItemsSortDirection: table_items_sort_direction,
	};
	
	const type_titles = {
		'cash':          'Gotovina',
		'cash-card':     'Plačilne kartice',
		'credit-card':   'Kartice',
		'bank-transfer': 'TRR',
		'gift-card':     'Bon',
		'other':         'Drugo',
	};

	return <div className='results mt-4 mb-4'>
		<div className='results-table'>
			<ResultHeader columnIdx={1} title='' />
			<ResultHeader columnIdx={2} title='Urejanje' />
			<ResultHeaderWithSort
				columnIdx={3} {...sort_props} title='Tip plačila' fieldName='type' />
			<ResultHeaderWithSort
				columnIdx={4} {...sort_props} title='Naziv' fieldName='title' />
			<ResultHeaderWithSort
				columnIdx={5} {...sort_props} title='Aktiven' fieldName='visible' />
			<ResultHeaderWithSort
				columnIdx={6} {...sort_props} title='Prikaži na bl. dok.' fieldName='show_in_cash_register_document' />
			<ResultHeaderWithSort
				columnIdx={7} {...sort_props} title='Vrstni red' fieldName='ord' />
		</div>
		
		<div className='results-table filters-row'>
			<Result columnIdx={1} />
			<Result columnIdx={2} />
			<Result columnIdx={3} />
			<Result columnIdx={4} child={
				<TextFilter
					value={tableItemsFilters.title}
					onChange={ event => handleFilterChange('title', event) } />
			} />
			<Result columnIdx={5} child={
				<Checkbox
					checked={tableItemsFilters.visible === 1}
					indeterminate={tableItemsFilters.visible === 0}
					onChange={event => {
						let checked = 0;
						if (tableItemsFilters.visible === 1) {
							checked = -1;
						}
						else if (tableItemsFilters.visible === 0) {
							checked = 1;
						}
						
						handleFilterChange('visible', checked);
					}} />
			} />
			<Result columnIdx={6} child={
				<Checkbox
					checked={tableItemsFilters.show_in_cash_register_document === 1}
					indeterminate={tableItemsFilters.show_in_cash_register_document === 0}
					onChange={event => {
						let checked = 0;
						if (tableItemsFilters.show_in_cash_register_document === 1) {
							checked = -1;
						}
						else if (tableItemsFilters.show_in_cash_register_document === 0) {
							checked = 1;
						}
						
						handleFilterChange('show_in_cash_register_document', checked);
					}} />
			} />
			<Result columnIdx={7} />
		</div>
		
		{table_items_sort_ids.map((id, idx) => {
			const item = table_items[id];
			
			return <div className='results-table' key={'payment-types-result--result-' + id}>
				<Result columnIdx={1} child={
					item.serial_internal_code
				} />
				<Result columnIdx={2} child={
					<>
						<Button
							icon='edit'
							intent='primary'
							minimal={true}
							small={true}
							onClick={() => openAddEditItemDialog(item)} />
						<Button
							icon='trash'
							intent='danger'
							minimal={true}
							small={true}
							onClick={() => deleteItem(item)} />
					</>
				} />
				<Result columnIdx={3} child={
					type_titles[item.type] || item.type
				} />
				<Result columnIdx={4} child={
					item.title
				} />
				<Result columnIdx={5} child={
					item.visible ?
						<Icon icon='tick' color='#394b59' />
						:
						<Icon icon='cross' color='#ff0000' />
				} />
				<Result columnIdx={6} child={
					item.show_in_cash_register_document ?
						<Icon icon='tick' color='#394b59' />
						:
						<Icon icon='cross' color='#ff0000' />
				} />
				<Result columnIdx={7} cls='text-right' child={
					item.ord
				} />
			</div>;
		})}
	</div>;
}

class PaymentTypes extends Component {
	constructor(props) {
		super(props);
		
		this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
		this.setTableItemsSort         = this.setTableItemsSort        .bind(this);
		this.refreshTableItemsSort     = this.refreshTableItemsSort    .bind(this);
		this.filterTableItems          = this.filterTableItems         .bind(this);
		this.handleFilterChange        = this.handleFilterChange       .bind(this);
		this.openAddEditItemDialog     = this.openAddEditItemDialog    .bind(this);
		this.closeAddEditItemDialog    = this.closeAddEditItemDialog   .bind(this);
		this.deleteItem                = this.deleteItem               .bind(this);
		
		const {
			table_items,
			table_items_sort_ids,
			table_items_filtered_ids,
		} = this.updateTableItemsFromProps(props);
		
		this.state = {
			table_items,
			table_items_sort_ids,
			table_items_filtered_ids,
			table_items_sort_field: 'ord',
			table_items_sort_direction: 'ASC',
			table_items_filters: {
				title:   '',
				visible: 0,
				show_in_cash_register_document: 0,
			},
			add_edit_item_dialog_open: false,
			add_edit_item_dialog_item: null,
			item_delete_requested: null,
		};
		
		this.state.table_items_sort_ids = this.refreshTableItemsSort(
			this.state.table_items_sort_field,
			this.state.table_items_sort_direction,
			this.state.table_items_filtered_ids,
			table_items,
			true
		);
	}
	
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.payment_types != this.state.table_items) {
			this.setState(
				this.updateTableItemsFromProps(this.props)
			);
		}
	}
	
	updateTableItemsFromProps(props) {
		const ids = Object.keys(props.payment_types);
		
		let sort_ids = [];
		
		if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) {
			for (let i=0; i<this.state.table_items_sort_ids.length; i++) {
				const id = this.state.table_items_sort_ids[i];
				if (ids.indexOf(id) != -1) {
					sort_ids.push(id);
				}
			}
		}
		
		for (let i=0; i<ids.length; i++) {
			const id = ids[i];
			if (sort_ids.indexOf(id) == -1) {
				sort_ids.push(id);
			}
		}
		
		const table_items_sort_ids = this.state === undefined ? sort_ids :
			this.refreshTableItemsSort(
				this.state.table_items_sort_field,
				this.state.table_items_sort_direction,
				ids,
				props.payment_types,
				true
			);
		
		return {
			table_items: props.payment_types,
			table_items_sort_ids,
			table_items_filtered_ids: ids,
		};
	}
	
	setTableItemsSort(field) {
		let direction = 'ASC';
		if (this.state.table_items_sort_field == field) {
			direction = (this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC');
		}
		
		this.setState({
			table_items_sort_field:     field,
			table_items_sort_direction: direction,
		});
		
		this.refreshTableItemsSort(field, direction);
	}
	
	refreshTableItemsSort(field, direction, table_items_filtered_ids, items, only_return) {
		table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
		items = items || this.state.table_items;
		only_return = only_return || false;
		
		const ids = table_items_filtered_ids;
		ids.sort((a_key, b_key) => {
			const a = items[a_key][field];
			const b = items[b_key][field];
			
			if (field == 'type' || field == 'title') {
				return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
			}
			
			return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
		});
		
		if (only_return) {
			return ids;
		}
		
		this.setState({
			table_items_sort_ids: ids,
		});
	}
	
	filterTableItems(filters) {
		const filters_title                          = filters.title.toUpperCase();
		const filters_visible                        = filters.visible;
		const filters_show_in_cash_register_document = filters.show_in_cash_register_document;
		
		const ids = Object.keys(this.state.table_items);
		const filtered_ids = ids.filter(id => {
			const item = this.state.table_items[id];
			
			if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) {
				return false;
			}
			
			if (filters_visible !== 0 &&
				(
					(item.visible === true  && filters_visible === -1) ||
					(item.visible === false && filters_visible ===  1)
				)
			) {
				return false;
			}
			
			if (filters_show_in_cash_register_document !== 0 &&
				(
					(item.show_in_cash_register_document === true  && filters_show_in_cash_register_document === -1) ||
					(item.show_in_cash_register_document === false && filters_show_in_cash_register_document ===  1)
				)
			) {
				return false;
			}
			
			return true;
		});
		
		this.setState({
			table_items_filtered_ids: filtered_ids,
			table_items_filters:      filters,
		});
		
		this.refreshTableItemsSort(
			this.state.table_items_sort_field,
			this.state.table_items_sort_direction,
			filtered_ids
		);
	}
	
	handleFilterChange(field_name, event) {
		const new_filters = {
			title:                          this.state.table_items_filters.title,
			visible:                        this.state.table_items_filters.visible,
			show_in_cash_register_document: this.state.table_items_filters.show_in_cash_register_document,
		};
		
		let val = event;
		if (val instanceof Object) {
			val = event.target.value;
		}
		new_filters[field_name] = val;
		
		this.filterTableItems(new_filters);
	}
	
	openAddEditItemDialog(item) {
		this.setState({ add_edit_item_dialog_open: true, add_edit_item_dialog_item: item });
	}
	closeAddEditItemDialog(item) {
		this.setState({ add_edit_item_dialog_open: false });
		
		if (item !== undefined) {
			this.props.dispatch(addPaymentType({ item, token: this.props.token, save_to_api: true }));
		}
	}
	deleteItem(item) {
		this.setState({ item_delete_requested: item, token: this.props.token });
	}
	
	render() {
		if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
		
		return <>
			{this.state.item_delete_requested === null ? null :
				<Alert
					cancelButtonText='Prekliči'
					confirmButtonText='Briši'
					canEscapeKeyCancel={true}
					canOutsideClickCancel={true}
					icon='trash'
					intent={Intent.DANGER}
					isOpen={true}
					onConfirm={() => {
						this.props.dispatch(deletePaymentType(this.state.item_delete_requested.id_payment_type));
						this.setState({ item_delete_requested: null });
					}}
					onCancel={() => {
						this.setState({ item_delete_requested: null });
					}}>
					Ali res želite izbrisati ta zapis?
				</Alert>
			}
			
			{!this.state.add_edit_item_dialog_open ? null :
				<AddEditPaymentType
					closeAddEditItemDialog={this.closeAddEditItemDialog}
					item={this.state.add_edit_item_dialog_item} />
			}
			
			<div className='flex flex-col flex-grow payment-types-list'>
				<div className='pl-4 pt-4'>
					<Button intent='primary' icon='plus' onClick={() => this.openAddEditItemDialog(null)}>
						Nov vnos
					</Button>
				</div>
				
				<div className='flex-1 pl-4 pr-4'>
					<div className='flex-grow overflow-y-auto' style={{ flexBasis: '0' }}>
						<Results
							table_items={this.state.table_items}
							table_items_sort_ids={this.state.table_items_sort_ids}
							table_items_sort_field={this.state.table_items_sort_field}
							table_items_sort_direction={this.state.table_items_sort_direction}
							setTableItemsSort={this.setTableItemsSort}
							openAddEditItemDialog={this.openAddEditItemDialog}
							tableItemsFilters={this.state.table_items_filters}
							handleFilterChange={this.handleFilterChange}
							deleteItem={this.deleteItem} />
					</div>
				</div>
			</div>
		</>;
	}
}
PaymentTypes.propTypes = {
};

function mapStateToProps(state) {
	return {
		payment_types: state.CodeTablesSlice.payment_types,
		token:         state.UserSlice.token,
		user:          state.UserSlice.user,
	};
}

export default connect(mapStateToProps)(PaymentTypes);
